module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/user-sources/user-sources.component.sass
// module id = ./src/app/payment/user-sources/user-sources.component.sass
// module chunks = main